import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react";
import PositionsAPI from "../API/PositionsAPI";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import PositionCard from "../components/lists/positionCard";
import PositionList from "../components/lists/positionList";
import PositionCardSubExpense from "../components/lists/positionCardSubExpense";
import ExpensesAPI from "../API/ExpensesAPI";
import useNotification from "../hooks/useNotification";

const Positions = () => {

    const { error } = useNotification();

    const [viewMode, setViewMode] = useState(0);
    const [objects, setObjects] = useState([]);
    const [newCell, setNewCell] = useState(null);
    const [expensesData, setExpenses] = useState([]);
    const [summParams, setSummParams] = useState({ summPay: 0, summTax: 0, summAdminPay: 0, summAdminTax: 0 });

    useEffect(() => {
        loadData().then(() => console.log("Список сотрудников загружен"));
        loadExpensesData().then(() => console.log("Список расходов загружен"));
    }, []);

    const loadData = async () => {
        try {
            const response = await PositionsAPI.getAll();
            if (response.status !== 200) throw response;

            setObjects(response.data);
            updateParams(response.data);
            return response.data;
        } catch (err) {
            console.log("[x] Ошибка загрузки списка сотрудников:", err);
        }
    }
    const loadExpensesData = async () => {
        try {
            setObjects([]);
            const response = await ExpensesAPI.getAll();
            if (response.status !== 200) throw response;

            setExpenses(response.data);
            return response.data;
        } catch (err) {
            console.log("[x] Ошибка загрузки расходов в блоке сотрдуников:", err);
        }
    }
    const updateParams = (data) => {
        if (!data) data = objects;
        let summPay = 0;
        let summTax = 0;
        for (let i = 0; i < data.positionsWorker.length; i++) {
            let worker = data.positionsWorker[i];
            summPay += worker.payment * worker.count;
            summTax += worker.payment * 0.302 * worker.count;
            // if (worker.isAdmin) pageSummValue[1] += worker.
        }

        let summAdminPay = 0;
        let summAdminTax = 0;
        for (let i = 0; i < data.positionsAdmin.length; i++) {
            let admin = data.positionsAdmin[i];
            summAdminPay += admin.payment * admin.count;
            summAdminTax += admin.payment * 0.302 * admin.count;
        }

        setSummParams({ 
            summPay, 
            summTax, 
            summAdminPay, 
            summAdminTax 
        });
    }

    // Редактирование должности
    const setValue = (index, value, field, isAdmin) => {
        let newObjects = objects;
        newObjects[isAdmin ? "positionsAdmin" : "positionsWorker"][index][field] = value;
        setObjects({...newObjects});
    }
    const removeValue = async (index, isAdmin) => {
        try {
            let newObjects = objects;
            console.log(newObjects[isAdmin?"positionsAdmin":"positionsWorker"][index].id)
            if (!newObjects[isAdmin?"positionsAdmin":"positionsWorker"][index].id) newObjects = await loadData();
            const response = await PositionsAPI.remove(newObjects[isAdmin?"positionsAdmin":"positionsWorker"][index].id);
            if (response.status !== 200) throw response;

            newObjects[isAdmin?"positionsAdmin":"positionsWorker"] = newObjects[isAdmin?"positionsAdmin":"positionsWorker"].filter((item, itemIndex) => itemIndex !== index);
            setObjects({...newObjects});
        } catch (err) {
            console.log("[x] Ошибка удаления сотрудника:", err);
            error("Ошибка удаления сотрудника");
        }
    }
    const saveValue = async (value) => {
        try {
            const response = await PositionsAPI.update(value);
            if (response.status !== 200) throw response;
            updateParams(objects);
        } catch (err) {
            console.log("[x] Ошибка обновления должности:", err);
            error("Ошибка сохранения должности");
        }
    }
    // Создание новой должности
    const addingValue = (isAdmin) => {
        setNewCell({ 
            name: "", 
            payment: 0, 
            count: 1, 
            isAdmin: isAdmin 
        });
    }
    const setValueNewCell = async (value, field) => {
        let newValue = newCell;
        newValue[field] = value;
        setNewCell({ ...newValue });
    }
    const saveNewCell = async (value) => {
        try {
            const response = await PositionsAPI.create(value);
            if (response.status !== 200) throw response;

            let newObjects = await loadData();
            setObjects(newObjects);
            updateParams(newObjects);
            setNewCell(null);
        } catch (err) {
            console.log("[x] Ошибка создания новой должности:", err);
            error("Ошибка создания должности");
        }
    }

    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="setupBlock">
            <div className="managementMenu">
                <div></div>
                <MultiSwitcherStage 
                    values={[{ name: "Показать всё" }, { name: "Руководящий состав" }, { name: "Рабочая группа" }]}
                    selectValue={(index) => setViewMode(index)}
                />
            </div>
            <ul className="setupCardList">
                {(viewMode == 0 || viewMode == 2) && <PositionList 
                    name="Рабочая группа" 
                    summ={formatNumber(Math.ceil(summParams.summPay)) + " ₽"} 
                    summTax={formatNumber(Math.ceil(summParams.summTax)) + " ₽"}
                    onCreate={() => addingValue(false)}
                >
                    {objects && objects.positionsWorker && objects.positionsWorker.length > 0 && objects.positionsWorker.map((item, index) => <PositionCard
                        key={item+index}
                        index={objects.positionsWorker.length - index - 1}
                        value={item}
                        setValue={(newValue, field) => setValue(index, newValue, field, false)}
                        saveValue={(value) => saveValue(value)}
                        onDelete={() => removeValue(index, false)}
                        opened={true}
                    >
                        {expensesData.map((expenseItem, expenseIndex) => 
                            <PositionCardSubExpense
                                key={expenseItem+expenseIndex}
                                index={expenseIndex}
                                name={expenseItem.name}
                                value={Math.ceil(expenseItem.cost / (summParams.summPay+summParams.summTax) * (item.payment * item.count + (item.payment * item.count * 0.302)))}
                            />
                        )}
                    </PositionCard>)}
                    {newCell && newCell.isAdmin === false && <PositionCard
                        index={-1}
                        value={newCell}
                        setValue={(newValue, field) => setValueNewCell(newValue, field)}
                        saveValue={(value) => saveNewCell(value)}
                        onDelete={() => setNewCell(null)}
                        opened={true}
                        isNew={true}
                    >
                        {expensesData.map((expenseItem, expenseIndex) => 
                            <PositionCardSubExpense
                                key={expenseItem+expenseIndex}
                                index={expenseIndex}
                                name={expenseItem.name}
                                value={Math.floor(expenseItem.cost / (summParams.summPay+summParams.summTax) * (newCell.payment * newCell.count + (newCell.payment * newCell.count * 0.302)))}
                            />
                        )}
                    </PositionCard>}
                </PositionList>}
                {(viewMode == 0 || viewMode == 1) && <PositionList 
                    name="Руководящий состав" 
                    summ={formatNumber(Math.ceil(summParams.summAdminPay)) + " ₽"} 
                    summTax={formatNumber(Math.ceil(summParams.summAdminTax)) + " ₽"}
                    onCreate={() => addingValue(true)}
                >
                    {objects && objects.positionsAdmin && objects.positionsAdmin.length > 0 && objects.positionsAdmin.map((item, index) => <PositionCard
                        key={item+index}
                        index={objects.positionsAdmin.length - index - 1}
                        value={item}
                        setValue={(newValue, field) => setValue(index, newValue, field, true)}
                        saveValue={(value) => saveValue(value)}
                        onDelete={() => removeValue(index, true)}
                        opened={false}
                    />)}
                    {newCell && newCell.isAdmin === true && <PositionCard
                        index={-1}
                        value={newCell}
                        setValue={(newValue, field) => setValueNewCell(newValue, field)}
                        saveValue={(value) => saveNewCell(value)}
                        onDelete={() => setNewCell(null)}
                        opened={true}
                        isNew={true}
                    />}
                </PositionList>}
            </ul>
        </div>
    )
}

export default observer(Positions);
